const theme = {
  background: '#f5f8fb',
  fontFamily: 'monospace',
  headerBgColor: '#9d49d1',
  iconColor: '#6E48AA',
  headerFontColor: '#fff',
  headerFontSize: '16px',
  botBubbleColor: '#6E48AA',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
  highlightColor: '#6E48AA',
  dragColor: '#c99ffc',
  warningColor: '#f5ad05'
};
export default theme;
